import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import CareLine from '../../models/core/careLine/CareLine';
import Category from '../../models/core/careLine/Category';
import VitalSign from '../../models/core/careLine/VitalSign';
import Exam from '../../models/core/careLine/Exam';
import Procedure from '../../models/core/careLine/Procedure';
import { FETCH_CARE_LINES, FETCH_DROPDOWN_DATA } from '../actions/careLine';

 
interface ICareLineReducer{ 
    careLines: CareLine[],
    allExams: Exam[],
    allProcedures: Procedure[],
    allCategories: Category[],
    allVitalSigns: VitalSign[]
}
 
const initialState: ICareLineReducer = {
    careLines: [],
    allExams: [],
    allProcedures: [],
    allCategories: [],
    allVitalSigns: []
} 
 
export const CareLineReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case FETCH_CARE_LINES:{
            return {
                ...cloneDeep(state),
                careLines: action.careLines
            }
        }
        case FETCH_DROPDOWN_DATA:{
            return {
                ...cloneDeep(state),
                allExams: action.exams,
                allProcedures: action.procedures,
                allCategories: action.categories,
                allVitalSigns: action.vitalSigns
            }
        }
       default:{
           return state
       }
   }
}
 